import { Button } from '@/components/ui/button'
import { Flex, IconButton } from '@chakra-ui/react'
import { MinusIcon, PlusIcon } from '../../_assets/icon-components'

interface ICounter {
  variable: number
  bg?: string | Record<string, string>
  onIncrease: () => void
  onDecrease: () => void
  min?: number
  height?: number | string | any
  max?: number
  isDisabled?: boolean
}

export default function Counter({
  min,
  max,
  bg,
  variable,
  onIncrease,
  onDecrease,
  isDisabled,
  height,
}: ICounter) {
  const resolvedBg = bg ?? 'light'
  const textColor =
    resolvedBg === 'product_button' ? 'product_button.text' : 'text'

  return (
    <Flex
      w='full'
      rounded={12}
      alignItems='center'
      bg={resolvedBg}
      color={textColor}
      justify='space-between'
      h={height ? height : 'auto'}
    >
      <IconButton
        h='full'
        pl={{ base: 2, lg: 3 }}
        variant='ghost'
        roundedLeft={12}
        onClick={onDecrease}
        justifyContent='flex-start'
        disabled={min === variable || isDisabled}
        flex={1}
        color={textColor}
      >
        <MinusIcon color='currentColor' />
      </IconButton>

      <Button
        w='20px'
        color={textColor}
        fontWeight={600}
        variant='plain'
        size='sm'
      >
        {variable}
      </Button>

      <IconButton
        h='full'
        pr={{ base: 2, lg: 3 }}
        color={textColor}
        variant='ghost'
        roundedRight={12}
        onClick={onIncrease}
        justifyContent='flex-end'
        disabled={max === variable || isDisabled}
        flex={1}
      >
        <PlusIcon color='currentColor' />
      </IconButton>
    </Flex>
  )
}
